<template>
  <div class="campus-remind-container" :class="{'wxMini': isWxMini}">
    <w-nav-bar v-if="!isWxMini" nav_title="网申提醒" @mobileLeftBtn="back"/>

    <div class="flex-between cell-item" @click.prevent="changeSwitch(3)">
      <span>待办事项提醒闹钟</span>
      <cube-switch v-model="toDoSwitch"/>
    </div>
    <p class="cell-description">在你的待办事项开始前，收到闹钟提醒，不错过任何一个关键时间节点</p>

    <div class="flex-between cell-item" @click.prevent="changeSwitch(2)">
      <span>最新网申提醒闹钟</span>
      <cube-switch v-model="newSwitch"/>
    </div>
    <p class="cell-description">不会错过任何名企网申信息，第一时间收到开启的新网申机会，有足够时间挑选和准备。</p>

    <div class="flex-between cell-item cell-first" @click.prevent="changeSwitch(1)">
      <span>关注网申提醒</span>
      <cube-switch v-model="favoriteSwitch"/>
    </div>
    <p class="cell-description">当你关注的企业，有行动网申开启时，网申时间更新时，网申还有7天截止时，都会及时收到提醒。</p>

    <w-wx-qr :wx-state="wxState" :qrUrl='qrUrl' @handleClose="wxState = false"></w-wx-qr>
  </div>
</template>

<script>
	import WNavBar from '../../components/global/w-navbar'
  import WWxQr from '../../components/global/w-wx-qr-remind'
	import { componentsMixin } from '../../assets/js/mixin/components'
  import { loginMixin, envMixin } from '../../assets/js/mixin/global'
	import { userMixin } from '../../assets/js/mixin/user'


	export default {
		name: 'campus-remind',
		mixins: [ componentsMixin, userMixin, loginMixin, envMixin ],
		data () {
			return {
				favoriteSwitch: null,
				newSwitch: null,
				toDoSwitch: null,
				wxState: false,
				qrUrl: ''
			}
		},
		async mounted () {
      this.verifyLogin()
      await this.loginByWx()
			this.getApplication()
		},
		computed: {},
		watch: {

		},
		components: {
			WNavBar,
			WWxQr
		},
		methods: {
		    verifyLogin() {
				if (!this.alreadyLogged) {
				  this.needLogin()
				}
		    },
			back () {
				this.$router.back()
			},
			async changeSwitch (tab) {
        let res = await this.$api.jobs.getTeamInfo()
        let completed = false
        if(res.code === 1000){
          completed = res.data.completed
          if(!completed){
            if (this.isWxMini) {
              this.$wechat.miniProgram.navigateTo({
                url: `/pages/fission/fission`
              })
              return
            }
          }
        }
				if (tab === 1) {
				    	// 关闭时 正常调接口关闭
						this.changeApplicetion({
						  type: 'wechat_self_net_application',
						  status: this.favoriteSwitch ? 'off' : 'on'
						})
				} else if (tab === 2) {
						// 关闭时 正常调接口关闭
						this.changeApplicetion({
						  type: 'wechat_all_net_application',
						  status: this.newSwitch ? 'off' : 'on'
						})

				} else if (tab === 3) {
						// 关闭时 正常调接口关闭
						this.changeApplicetion({
						  type: 'wechat_to_do_net_application',
						  status: this.toDoSwitch ? 'off' : 'on'
						})
				}
			},
			async getApplication () {
				let res = await this.$api.jobs.getNetApplication()
				if (res.code === 1000) {
					this.favoriteSwitch = res.data.wechat_self_net_application_status
					this.newSwitch = res.data.wechat_all_net_application_status
					this.toDoSwitch = res.data.wechat_to_do_net_application_status
				}
			},
			async changeApplicetion (payload) {
				let res = await this.$api.jobs.changeNetApplication(payload)
				if (res.code === 1000) {
					if (payload.type === 'wechat_self_net_application') {
						this.favoriteSwitch = payload.status === 'on'
					} else if (payload.type === 'wechat_all_net_application') {
						this.newSwitch = payload.status === 'on'
					} else if (payload.type === 'wechat_to_do_net_application') {
						this.toDoSwitch = payload.status === 'on'
					}
					this.showToast(payload.status === 'on' ? '网申提醒已开启' : '网申提醒已关闭')
				} else if (res.code === 2027) {
					//console.log(res)
					 let c_t =  this.cvAccountToken
					 //console.log(c_t)
					let query = {
					 scene_str: 'bind_'+ c_t,
					 account_type: 'cv_account',
					 operation_type :'bind',
					 expire_seconds: 20
					}
					let wxCode = await this.$api.auth.getRemindCode(query)
					if (wxCode.code === 1000) {
					  this.qrUrl = wxCode.data.url
					}
					//console.log(wxCode,this.qrUrl,wxCode.data.qr_url)
				  	this.wxState = true
 				    this.wxState = true
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/global/variable';
  @import '@/assets/scss/global/mixin';
  .campus-remind-container {
    @include mobile-container(44px, 1px);
    background-color: #F9F9F9;
    min-height: $screen-height;
    &.wxMini {
      padding-top: 0;
    }
    .cell-first {
      margin-top: 6px;
    }
    .cell-item {
      height: 48px;
      padding: 0 24px;
      background-color: $color-light;
      span {
        color: $color-title;
        font-size: $font-size-medium-x;
      }
    }
    .cell-description {
      color: $color-light-gray;
      line-height: 22px;
      font-size: $font-size-small;
      margin: 10px 0;
      padding: 0 24px;
    }
    /deep/ .cube-switch .cube-switch-input:checked + .cube-switch-ui {
      background-color: #ff6644;
      border-color: #ff6644;
    }
    /*/deep/ .cube-switch-input, /deep/ .cube-switch-ui {*/
    /*  width: 48px;*/
    /*  height: 18px;*/
    /*  border-radius: 14px;*/
    /*}*/
    /*/deep/ .cube-switch-ui::after {*/
    /*  width: 18px;*/
    /*  height: 18px;*/
    /*  border-radius: 50%;*/
    /*}*/
  }
</style>
